import BaseRepository from '../../../baseRepository/BaseRepository';
const resource = `/api/v1/traderequests`;
const documentTypeResource = `/api/v1/tradedocumenttypes`;
const eventResourse = `/api/v1/traderequestevents`;
export default {
  getTradeRequestMembershipAndPrice(
    id,
    baseURL = {},
    headers = {},
    params = {}
  ) {
    return BaseRepository.get(`${resource}/${id}/membership-and-price`, {
      baseURL,
      headers,
      params,
    });
  },
  getTradeRequests(baseURL = {}, headers = {}, params = {}, paramsSerializer) {
    return BaseRepository.get(`${resource}`, {
      baseURL,
      headers,
      params,
      paramsSerializer,
    });
  },
    getDirectTradeRequests(baseURL = {}, headers = {}, params = {}, paramsSerializer) {
    return BaseRepository.get(`${resource}/by-supplier`, {
      baseURL,
      headers,
      params,
      paramsSerializer,
    });
  },
  finalize(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(
      `${resource}/${id}/finalize`,
      {},
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  getTradeRequestById(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/${id}`, {
      baseURL,
      headers,
      params,
    });
  },
  getLimitationById(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/${id}/for-edit-limitations`, {
      baseURL,
      headers,
      params,
    });
  },
  getTechInfoById(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/${id}/for-edit-tech-info`, {
      baseURL,
      headers,
      params,
    });
  },
  getTradeRequestEvents(
    baseURL = {},
    headers = {},
    params = {},
    paramsSerializer = {}
  ) {
    return BaseRepository.get(`${eventResourse}`, {
      baseURL,
      headers,
      params,
      paramsSerializer,
    });
  },
  getTradeRequestEventsById(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${eventResourse}/${id}/bysupplier`, {
      baseURL,
      headers,
      params,
    });
  },
  addTradeRequest(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}`, body, {
      baseURL,
      headers,
      params,
    });
  },
   addTradeRequestDirect(body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}/direct-order`, body, {
      baseURL,
      headers,
      params,
    });
  },
  sendConfirmRequest(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(
      `${resource}/${id}/request-confirmation`,
      {},
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  confirmAndPublishDirectOrder(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(
      `${resource}/${id}/confirm-and-publish`,
      {},
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  editTradeRequest(id, body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.put(`${resource}/${id}`, body, {
      baseURL,
      headers,
      params,
    });
  },
    editDirectOrderTradeRequest(id, body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.put(`${resource}/direct-order/${id}`, body, {
      baseURL,
      headers,
      params,
    });
  },
  deleteTradeRequestById(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.delete(`${resource}/${id}`, {
      baseURL,
      headers,
      params,
    });
  },
  getDocumentType(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${documentTypeResource}`, {
      baseURL,
      headers,
      params,
    });
  },
  deleteTradeRequestLimitation(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(
      `${resource}/${id}/remove-limitations`,
      {},
      {
        baseURL,
        headers,
        params,
      }
    );
  },
  editTradeRequestLimitation(
    id,
    body,
    baseURL = {},
    headers = {},
    params = {}
  ) {
    return BaseRepository.post(`${resource}/${id}/edit-limitations`, body, {
      baseURL,
      headers,
      params,
    });
  },
  editTradeRequestTechInfo(id, body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}/${id}/edit-tech-info`, body, {
      baseURL,
      headers,
      params,
    });
  },
  getDocumentsByIds(
    id,
    baseURL = {},
    headers = {},
    params = {},
    paramsSerializer
  ) {
    return BaseRepository.get(`${resource}/${id}/documents`, {
      baseURL,
      headers,
      params,
      paramsSerializer,
    });
  },
  getContributerInfo(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/${id}/stat/item`, {
      baseURL,
      headers,
      params,
    });
  },
  submitDateExtension(id, body, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.post(`${resource}/${id}/extend`, body, {
      baseURL,
      headers,
      params,
    });
  },
};
